import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    showMore: string;
    noProjects: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Button text to show more projects */
            showMore: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectList.showMore?c=19xfnlid72cde", defaultMessage: "Show More" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Empty state text when workspace has no projects */
            noProjects: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectList.noProjects?c=1rkmz4sjyappp", defaultMessage: "No projects" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
